<!-- no divs here to integrate nicely into his-search-select -->

<!-- custom select button with image, no text -->
@if (selectButtonImage && searchConfigFile) {
  <button #inputElement
    type="submit" [disabled]="!editMode"
    class="icon" [hisImage]="selectButtonImage"
    [title]="selectButtonTooltip" alt="" [attr.aria-describedby]="errortextId ? errortextId: ''"
    (click)="showSearchFormResultComponent(); $event.preventDefault();">
  </button>
}
<!-- default select button -->
@if (!selectButtonImage && searchConfigFile) {
  <button #inputElement
    type="submit" [disabled]="!editMode"
    class="transparent selectButton" hisImage="ARROW_RIGHT_FAT" alt="" [attr.aria-describedby]="errortextId ? errortextId: ''"
    (click)="showSearchFormResultComponent(); $event.preventDefault();">
    <span>{{(selectedOptions?.length > 0) ? (changeSelectedItemsButtonLabel ? changeSelectedItemsButtonLabel : ('genericSearch.changeSelectedItems' | hisUi)) : (selectItemsButtonLabel ? selectItemsButtonLabel : ('genericSearch.selectItems' | hisUi))}}</span>
  </button>
}
@if (showDeleteButton && (selectionSetting === selectionSettingEnum.MultiSelect) && selectedOptions.length > 0 && searchConfigFile) {
  <button type="submit"
    class="transparent selectButton" hisImage="PANEL_CLOSE" alt="" [attr.aria-describedby]="errortextId ? errortextId: ''"
    (click)="deleteAllSelectedOptions(); $event.preventDefault();">
    <span>{{'genericSearch.deleteSelectedItems' | hisUi}}</span>
  </button>
}

<!-- Using the pFocusTrap directive on the content of p-dialog instead of it's own
focusTrap attribute fixes that tabbing always starts on top of the dialog.
See https://github.com/primefaces/primeng/issues/7754 -> Removed for #266927 -->

<p-dialog
  appendTo="body" styleClass="minWidth90"
  [(visible)]="searchFormResultComponentVisible"
  [modal]="true" [blockScroll]="true" [focusTrap]="true"
  (onHide)="hideSearchFormResultComponent()"
  [header]="(formTitle || genericFallbackTitle ) | hisUi">
  @if (searchConfigFile) {
    <div class="searchresult">
      @if (searchFormResultComponentVisible) {
        <his-search-form-result
          #SearchFormResultComponent
          [renderTitle]="false"
          [searchConfigFile]="searchConfigFile"
          [genericSearchRowTooltipId]="genericSearchRowTooltipId"
          [selectedOptions]="selectedOptions"
          [selectedOptionsIdColumn]="selectedOptionsIdColumn"
          [selectedOptionsLabelColumn]="selectedOptionsLabelColumn"
          [isSearchPopup]="true"
          [resultRowsPerPage]="resultRowsPerPage"
          [selectionSetting]="selectionSetting"
          [renderCustomBottomResultButtons]="false"
          [presetInputFields]="presetInputFields"
          (selectionSubmited)="onSubmitSearchFormResultComponent($event)"
          (selectionCanceled)="hideSearchFormResultComponent()"
          (readSearchSetSubmit)="readSearchSetFromSearch($event)"
          (finishedInitialLoad)="onFinishedInitialLoad()"
          (formTitleLoaded)="onFormTitleLoaded($event)"
          [defaultSearchGroup]="defaultSearchGroup"
          [hiddenSearchCriteriaPaths]="hiddenSearchCriteriaPaths"
          [showTableFilter]="showTableFilter"
          [searchShowPrintviewButton]="false"
          [hierarchyLevel]="hierarchyLevel">
          <p passToForm>
            <ng-content select="[passToPopUp]"></ng-content>
          </p>
        </his-search-form-result>
      }
    </div>
  }
  <ng-content></ng-content>

  
  <ng-template #footer>
    @if (showFooterButtons && selectionSetting === selectionSettingEnum.MultiSelect) {
        <ng-container>
          <button iconPos="left" hisImage="TICK" class="marginRightStandard"
                  (click)="searchFormResultComponent.submitSelection();">
            <span>{{'genericSearch.returnSelected' | hisUi}}</span>
          </button>
          <button iconPos="left" hisImage="RED_X" 
                  (click)="searchFormResultComponent.cancelSelection();">
            <span>{{'genericSearch.backToParentSearch' | hisUi}}</span>
          </button>
        </ng-container>
      }
  </ng-template>
  
</p-dialog>

